import EmptyState from '../components/EmptyState';

export default function Viva() {
  return (
    <EmptyState
      title="Viva"
      description="Content-creator platform pipeline management"
    />
  );
}
